import * as React from "react"
import { Loader2 } from "lucide-react"
import { cn } from "../../lib/utils"

interface LoadingSpinnerProps {
  message?: string
  className?: string
  size?: "sm" | "default" | "lg"
}

export function LoadingSpinner({ 
  message = "Loading...", 
  className,
  size = "default" 
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: "h-4 w-4",
    default: "h-6 w-6",
    lg: "h-8 w-8"
  }

  return (
    <div className={cn("flex flex-col items-center justify-center p-8 space-y-2", className)}>
      <Loader2 className={cn("animate-spin text-muted-foreground", sizeClasses[size])} />
      {message && (
        <p className="text-sm text-muted-foreground">{message}</p>
      )}
    </div>
  )
}